<template>
  <b-modal
    modal-class="submit-modal"
    v-model="editorShown"
    :title="modalTitle"
    @hidden="onHidden"
    centered
    :size="modalSize"
    no-close-on-backdrop
    header-bg-variant="light"
    header-class="p-0 d-block shadow-form bg-purple"
    footer-class="bg-extra-light-gray shadow-form"
    hide-footer
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center text-white"
        style="padding: 13px 20px;"
      >
        <div>
          <h5 class="modal-title font-weight-bold">{{ modalTitle }}</h5>
        </div>
        <button
          type="button"
          aria-label="Close"
          class="close text-white"
          style="opacity:1 !important"
          @click="closeModal"
        >
          ×
        </button>
      </div>
    </template>
    <div class="d-flex h-100 position-relative overflow-auto">
      <div class="flex-grow-1 position-relative p-3">
        <b-row>
          <b-col>
            <div class="text-center">
              <div class="builder w-100">
                <fb-form-viewer
                  v-if="layout"
                  :json="layout"
                  showType="form-submitter"
                ></fb-form-viewer>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  name: "FormBuilderPreviewModal",
  props: ["form", "json", "modalSize", "modalTitle"],
  data() {
    return {
      eoc: null,
      showSidebar: false,
      layout: null
    };
  },
  async mounted() {
    this.initializeFormSubmitter();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setInitialValues"
    ]),
    ...mapActions("formSubmitter", [
      "initializeFormSubmitterForm"
    ]),
    onHidden() {},
    async initializeFormSubmitter() {
      await this.setInitialValues();

      await this.initializeFormSubmitterForm({
        formId: "previewForm",
        formName: this.modalTitle,
        version: {
          content: this.json
        },
        client: null,
        eoc: null,
        document: null,
        showType: "form-submitter"
      });

      this.layout = this.json.layout;
    },
    closeModal() {
      this.$emit("onModify");
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>

div >>> .dropdown-menu {
  width: 100%;
}

.disable-form {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  opacity: 0.3;
}

.modal-subtitle {
  font-size: 14px;
  margin-top: -4px;
}

.status-badge {
  font-size: 16px;
  padding: 10px 18px !important;
}

.sidebar {
  width: 60px;
  height: 100%;
  background-color: #f5f8fc;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: width 375ms ease;
}

.sidebar.sidebar-open {
  width: 400px;
}

.sidebar-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  top: 60px;
  left: 45px;
  width: 400px;
  height: calc(100% - 70px);
  padding: 0 15px 15px;
  transition: left 375ms ease;
}

.sidebar-body > * {
  margin-bottom: 0;
}

.sidebar.sidebar-open .sidebar-body {
  left: 0;
}

.hamburger {
  padding: 15px 15px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}

.hamburger:focus-visible {
  outline-width: 0;
}

.hamburger:hover {
  opacity: 0.7;
}

.hamburger.is-active:hover {
  opacity: 0.7;
}

.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #000;
}

.hamburger-box {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
}

.hamburger-inner,
.hamburger-inner::before,
.hamburger-inner::after {
  width: 30px;
  height: 3px;
  background-color: #000;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}

.hamburger-inner::before,
.hamburger-inner::after {
  content: "";
  display: block;
}

.hamburger-inner::before {
  top: -10px;
}

.hamburger-inner::after {
  bottom: -10px;
}

.hamburger--squeeze .hamburger-inner {
  transition-duration: 0.075s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--squeeze .hamburger-inner::before {
  transition: top 0.075s 0.12s ease, opacity 0.075s ease;
}

.hamburger--squeeze .hamburger-inner::after {
  transition: bottom 0.075s 0.12s ease,
    transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--squeeze.is-active .hamburger-inner {
  transform: rotate(45deg);
  transition-delay: 0.12s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}

.hamburger--squeeze.is-active .hamburger-inner::before {
  top: 0;
  opacity: 0;
  transition: top 0.075s ease, opacity 0.075s 0.12s ease;
}

.hamburger--squeeze.is-active .hamburger-inner::after {
  bottom: 0;
  transform: rotate(-90deg);
  transition: bottom 0.075s ease,
    transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
}
</style>
<style>
.submit-modal .shadow-footer-sm {
  box-shadow: 0px -8px 5px -7px rgb(0 0 0 / 8%);
}
.toggle-statuses:hover {
  background-color: #f5f8fc !important;
}
.shadow-form {
  box-shadow: 0px 0px 14px -2px rgba(0, 0, 0, 0.5);
}
</style>
